module.exports = __webpack_public_path__ + "img/15.20db0541.jpg";